import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Blood product',
  description: 'Blood products obtained from blood donations',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    status: types.STRING_INDEX, // usage
    volume: types.NUMBER,
    expiryDate: types.DATE_INDEX,
    details: types.STRING,

    bloodType: types.STRING_INDEX,
    bloodProductType: types.OBJECT,
    facility: types.OBJECT,
    processing: types.OBJECT,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'status', 'bloodProductType', 'processing'],
  indexes: ['expiryDate'],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
